import type { SVGProps } from 'react'

function attrs(props: SVGProps<SVGSVGElement>) {
  return {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    ...props,
  }
}

export function IconMenu(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <line x1="4" x2="20" y1="6" y2="6" />
      <line x1="4" x2="20" y1="12" y2="12" />
      <line x1="4" x2="20" y1="18" y2="18" />
    </svg>
  )
}

/** Enter focus / expand content */
export function IconExpand(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <polyline points="15 3 21 3 21 9" />
      <polyline points="9 21 3 21 3 15" />
      <line x1="21" x2="14" y1="3" y2="10" />
      <line x1="3" x2="10" y1="21" y2="14" />
    </svg>
  )
}

/** Exit focus / compress */
export function IconCompress(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <polyline points="4 14 10 14 10 20" />
      <polyline points="20 10 14 10 14 4" />
      <line x1="14" x2="21" y1="10" y2="3" />
      <line x1="3" x2="10" y1="21" y2="14" />
    </svg>
  )
}

export function IconSun(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  )
}

export function IconMoon(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
    </svg>
  )
}

export function IconPlus(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  )
}

export function IconMinus(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <path d="M5 12h14" />
    </svg>
  )
}

/** Cash / bills — payment method affordance */
export function IconCash(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <rect x="2" y="6" width="20" height="12" rx="2" />
      <circle cx="12" cy="12" r="2" />
      <path d="M6 12h.01M18 12h.01" />
    </svg>
  )
}

/** Bank transfer — payment method affordance */
export function IconTransfer(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <path d="M6 15l-3-3 3-3M3 12h15M18 9l3 3-3 3M21 12H6" />
    </svg>
  )
}

export function IconCart(p: SVGProps<SVGSVGElement>) {
  return (
    <svg {...attrs(p)}>
      <path d="M2.25 3h1.386c.51 0 .955.343 1.084.835l1.417 4.385h11.228l2.045 6.318c.04.125.061.25.061.378 0 .487-.395.882-.882.882H5.318l-.75 2.25M16.5 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM8.25 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
    </svg>
  )
}
